import { createGlobalStyle } from 'styled-components';

export const theme = {
  body: {
    dark: '#ffffff',
    light: '#595959',
  },
  heading: {
    dark: '#ffffff',
    light: '#3F3356',
  },
  background: {
    gray: '#e5e5e5',
    lightGray: '#f2f2f2',
    light: '#ffffff',
    blue: '#5986ff',
  },
  navbar: {
    dark: '#1F2432',
    light: '#ffffff',
  },
  textColor: {
    blackText: '#000000',
    lightBlack: '#202020',
    darkGrayText: '#262626',
    blueText: '#2F80ED',
    suvaGray: '#8c8c8c',
    silverText: '#C4C4C4',
    linkText: '#2753D7',
  },
  borderColor: {
    silver: '#C4C4C4',
    blueBorder: '#5986ff',
    grayBorder: '#e5e5e5',
    lightGray: '#E9E9E9',
    darkGray: '#424859',
  },
  blockquote: {
    dark: '#f6f6f6',
  },
  icon: {
    blueIcon: '#5986FF',
    redIcon: '#DD4B4B',
    whiteIcon: '#FFFFFF',
  },
  hover: {
    hoverBlue: '#5986ff',
    hoverBlack: '#000000',
    hoverLight: '#4d74dc',
  },
  priceColor: {
    essential: '#FFD05C',
    standard: '#2BCA86',
    professional: '#5986FF',
    enterprise: '#DD4B4B',
    price: '#2C3346',
  },
  table: {
    dark: '#ffffff',
    light: 'rgba(89,134,255,0.05)',
  },
  boxShadow: {
    light: 'rgba(0, 0, 0, 0.15)',
  }
};

export default createGlobalStyle`
  body {
    color: ${props => theme.body[props.theme]};
    font-size: ${theme.body.fontSize};
    line-height: 1.1875rem;
    /* Handles navbar fixed */
    padding-top: 3.8125rem;
    scroll-behavior: smooth;
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
  }
  h1, h2, h3, h4, h5, h6 {
    color: ${props => theme.heading[props.theme]};
  }
  h1, h2, h3 {
    font-weight: bold;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  .no-scroll {
    overflow: hidden;
  }
  [id]::before {
    display: block;
    content: '';
    margin-top: -4rem;
    height: 4rem;
  }
  .centered-text {
    text-align: center;
  }
  .section {
    padding: 94px 0;
    h1, h2, h3, h4, h5, h6 {
      color: ${theme.textColor.darkGrayText};
    }
  }
  .hover-text {
    text-decoration: none;
    :hover {
      text-decoration: underline;  
    }
  }
  .plan-table {
    background: ${theme.table.light};
    tr {
      border: 0px !important;
      th, td {
        text-align: center;
        color: ${theme.textColor.darkGrayText};
        border: 0;
        border-right: 1px solid ${theme.table.dark};
        font-size: 16px;
        line-height: 1.2;
        padding: 21px 0;
        width: 19%;
      }
      th {
        font-weight: bold;
        font-size: 18px;
        background: ${theme.table.light};
        margin-bottom: 20px;
        padding: 21px 0;
      }
      th:nth-child(1) {
        text-align: left;
        max-width: 372px;
        width: 24%;
        padding-left: 42px;
        background: none;
        border-right: 0;
      }
      td {
        padding: 15px 0;
      }
      td:nth-child(1) {
        text-align: left;
        max-width: 372px;
        width: 24%;
        padding-left: 42px;
        border-right: 0;
        font-size: 18px;
      }
    }
    tr:nth-child(2) {
      td {
        padding-top: 40px !important;  
      }
    }
    tr:last-child {
      td {
        padding-bottom: 55px;
      }
    }
  }
  @media(max-width: 767px) {
    .section {
      padding: 35px 0;
    }
  }
`;
